import i18n from "@/plugins/i18n";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faBalanceScale,
  faBars,
  faBorderAll,
  faCaretDown,
  faCheck,
  faDesktop,
  faEdit,
  faEnvelope,
  faExchangeAlt,
  faHistory,
  faHome,
  faInfoCircle,
  faList,
  faPaperPlane,
  faSave,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTimes,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Aura from "@primeuix/themes/aura";
import * as Sentry from "@sentry/vue";
import { createSentryPiniaPlugin } from "@sentry/vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import { createApp, h } from "vue";
import App from "./App";
import router from "./router";

// IMPORT FONTAWESOME 5
// ADD ICONS TO LIBRARY

library.add(
  faAngleDown,
  faBalanceScale,
  faBars,
  faBorderAll,
  faCaretDown,
  faCheck,
  faDesktop,
  faEdit,
  faEnvelope,
  faExchangeAlt,
  faHistory,
  faHome,
  faInfoCircle,
  faList,
  faPaperPlane,
  faSave,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTimes,
  faUserPlus,
);

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());
const app = createApp({
  setup() {
    return () => h(App);
  },
});
app.component("font-awesome-icon", FontAwesomeIcon);
app.config.productionTip = false;

Sentry.init({
  app,
  environment: import.meta.env.VITE_LANG_VERSION,
  dsn: "https://baf13fd25ebd7bd7b9b101f70babd796@o4508444386131968.ingest.de.sentry.io/4508489722167376",
  normalizeDepth: 10,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/taxedesejour-airbnb\.fr\/api/,
    /^https:\/\/tassadisoggiorno-airbnb\.it\/api/,
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

app.use(router);
app.use(pinia);
app.use(i18n);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: "",
    },
  },
});
app.use(ToastService);
app.component("Toast", Toast);

router.isReady().then(() => app.mount("#app"));

window.app = app;
